import React from "react";

export default function SegmentEditor({
  seg,
  idx,
  edits,
  FPS,
  duration,
  updateEdit,
  removeEdit,
  goToFrame,
}: any) {
  if (!seg) return null;

  const prevEnd = idx > 0 ? Math.round(edits[idx - 1].end * FPS) : 0;
  const nextStart =
    idx < edits.length - 1
      ? Math.round(edits[idx + 1].start * FPS)
      : Math.round(duration * FPS);

  return (
    <div className="bg-gray-900/90 rounded-xl mt-4 mb-2 shadow-lg max-w-full px-6 py-5 border border-brand_200 flex flex-col gap-3">
      <span className="block font-bold mb-2 text-sm text-white">
        Effet {idx + 1}
      </span>
      <div className="flex flex-wrap items-center gap-3 min-w-0 max-w-full overflow-x-auto">
        <label className="flex items-center gap-2 min-w-0">
          <span className="text-xs text-brand_gray font-semibold">Start</span>
          <input
            type="number"
            min={prevEnd}
            max={Math.floor(seg.end * FPS) - 1}
            value={Math.round(seg.start * FPS)}
            className="w-14 px-2 py-2 text-xs rounded-md border border-brand_200 bg-gray-800 text-white focus:outline-none focus:border-brand_focus transition"
            onChange={e =>
              updateEdit(idx, {
                start: Math.max(
                  prevEnd / FPS,
                  Math.min(Number(e.target.value) / FPS, seg.end - 1 / FPS)
                )
              })
            }
          />
          <button
            className="btn-dark-secondary ml-1 h-7 px-2 py-1 text-xs"
            onClick={() => goToFrame(seg.start)}
            type="button"
          >
            Aller
          </button>
        </label>
        <label className="flex items-center gap-2 min-w-0">
          <span className="text-xs text-brand_gray font-semibold">End</span>
          <input
            type="number"
            min={Math.ceil(seg.start * FPS) + 1}
            max={nextStart}
            value={Math.round(seg.end * FPS)}
            className="w-14 px-2 py-2 text-xs rounded-md border border-brand_200 bg-gray-800 text-white focus:outline-none focus:border-brand_focus transition"
            onChange={e =>
              updateEdit(idx, {
                end: Math.max(
                  seg.start + 1 / FPS,
                  Math.min(Number(e.target.value) / FPS, nextStart / FPS, duration)
                )
              })
            }
          />
          <button
            className="btn-dark-secondary ml-1 h-7 px-2 py-1 text-xs"
            onClick={() => goToFrame(seg.end)}
            type="button"
          >
            Aller
          </button>
        </label>
        <label className="flex items-center gap-2 min-w-0">
          <span className="text-xs text-brand_gray font-semibold">Speed</span>
          <select
            value={seg.speed}
            onChange={e =>
              updateEdit(idx, {
                speed: e.target.value === "cut" ? "cut" : parseFloat(e.target.value)
              })
            }
            className="w-16 px-2 py-1 text-xs rounded-md border border-brand_200 bg-gray-800 text-white font-semibold focus:outline-none focus:border-brand_focus transition"
          >
            {[1, 1.5, 2, 3, 4, "cut"].map(val => (
              <option value={val} key={val}>
                {val === "cut" ? "CUT" : `x${val}`}
              </option>
            ))}
          </select>
        </label>
        <button
          className="btn-delete ml-2 px-3 py-1 text-xs"
          onClick={() => removeEdit(idx)}
          type="button"
        >
          Suppr
        </button>
      </div>
    </div>
  );
}